import { useEffect, useState } from 'react';
import { currentLayout, subscribeLayout } from '../utils/layoutMode';

// For the (few) places that need a different component TREE on phones, not
// just different styles - e.g. the mobile voice bar/sheet. Pure styling
// differences belong in CSS keyed off <html data-layout> instead (see
// utils/layoutMode.js), so desktop markup stays byte-for-byte identical.
export function useLayoutMode() {
    const [layout, setLayout] = useState(currentLayout);
    useEffect(() => subscribeLayout(setLayout), []);
    return {
        layout,
        isMobile: layout !== null,
        isMobileLandscape: layout === 'mobile-landscape'
    };
}
